import { render, staticRenderFns } from "./ItsSalesDepart.vue?vue&type=template&id=b9385b00&scoped=true&"
import script from "./ItsSalesDepart.vue?vue&type=script&lang=js&"
export * from "./ItsSalesDepart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9385b00",
  null
  
)

export default component.exports